import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			gcTime: 10 * 60 * 1000, // 10 minutes
			retry: false,
			refetchOnWindowFocus: false,
		},
		mutations: {
			networkMode: "always",
			retry: false,
		},
	},
});

export function getContext() {
	return {
		queryClient,
	};
}
